/**
 * ╔══════════════════════════════════════════════════════════════════════════════════════════════╗
 * ║                                   SUPABASE CLIENT                                            ║
 * ║                    Production-Ready Database Connection for React Web App                    ║
 * ╚══════════════════════════════════════════════════════════════════════════════════════════════╝
 */

import { createClient } from '@supabase/supabase-js'

// Clock-It-Alpha project configuration - NO FALLBACKS
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Validate environment variables
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Missing Supabase environment variables')
  console.error('Required: VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY')
}

// Create Supabase client with production configuration
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    debug: import.meta.env.DEV
  },
  global: {
    headers: {
      'X-Client-Info': 'clock-it-react-web@1.0.0'
    }
  }
})

// Development logging
if (import.meta.env.DEV) {
  console.log('🔗 Supabase client initialized:', {
    url: supabaseUrl,
    hasAnonKey: !!supabaseAnonKey,
    environment: import.meta.env.MODE
  })
}

// Export types for TypeScript support - FIXED PATH
// export type { Database } from '../src/lib/database.types'  // DISABLED - circular import issue